import { BackendError, CashActionResponseMessage } from '@eih-netbroker/common';
import { atom } from 'jotai';

export type CashActionTemp = {
  amount: string;
  currencyCode: string;
  sourceAccountNumber?: string;
  sourceAccountCategory?: string;
  sourceClientId: string;
  targetAccountNumber?: string;
  targetAccountCategory?: string;
  targetClientId: string;
};

export enum CashActionStep {
  Params = 'params',
  Summary = 'summary',
  Confirm = 'confirm',
  ReceivedMessages = 'receivedMessages',
}

export const cashActionTempAtom = atom<CashActionTemp | null>(null);
export const cashActionStepAtom = atom<CashActionStep>(CashActionStep.Params);
export const getTargetAccountAborterAtom = atom<AbortController | undefined>(undefined);
export const tempIdAtom = atom<string | undefined>(undefined);
export const smsCodeErrorAtom = atom<BackendError | undefined>(undefined);
export const receivedMessagesAtom = atom<Array<CashActionResponseMessage>>([]);
